export default __webpack_public_path__ + "static/media/Claymore of the Death Master.84bb0124.jpg";